import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FluentHoverComponent } from './fluent-hover.component';
import { SharedProviderModule } from '~app/shared/shared.module';
import { QmPipesModule } from '~app/components/qm-pipes/qm-pipes.module';
import { ElementDetailsModule } from '~app/element-details/element-details.module';

@NgModule({
  declarations: [ FluentHoverComponent ],
  imports: [
    SharedProviderModule,
    QmPipesModule,
    ElementDetailsModule
  ],
  exports: [
    FluentHoverComponent
  ],
  providers: [],
})
export class FluentInfoModule {}
